import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { REGISTRATION_PROFILE_BASE_PATH } from '../../../../../features/registration/profile/registration-profile-routing';

// This route exists solely to provide a breadcrumb for children of the profile page group.
export const Route = createFileRoute('/_app/_clearing-core/registration/profile/_profile')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'profile-list',
        label: 'Registration',
        to: REGISTRATION_PROFILE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
